import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '../Button';
import SubMenu from './SubMenu';
import ActionLinks from './ActionLinks';

import * as styles from './MobileNav.module.less';

const MobileNav = props => {
  const { links, headerButton, isVisible, navigationLinks } = props;

  const classes = classnames(styles.mobileNav, {
    [styles.navBarPillarNavHidden]: !isVisible,
  });

  return (
    <div className={classes}>
      <div className={styles.pillarNavWrapper}>
        <ActionLinks links={links} />
        {headerButton && (
          <div className={styles.pillarNavMainSection}>
            <Button
              isLink
              linkHref={headerButton.url}
              size="small"
              className={classnames(
                styles.pillarNavApplyBtn,
                styles.mobileNavPPP
              )}
            >
              {headerButton.text}
            </Button>
          </div>
        )}
        <ul className={styles.pillarNavMenu}>
          {navigationLinks.map(navLink => (
            <SubMenu links={navLink} key={navLink.path || navLink.name} />
          ))}
        </ul>
      </div>
    </div>
  );
};

MobileNav.propTypes = {
  links: PropTypes.shape({}).isRequired,
  headerButton: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  isVisible: PropTypes.bool,
  navigationLinks: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};

MobileNav.defaultProps = {
  headerButton: null,
  isVisible: false,
  navigationLinks: [],
};

MobileNav.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
      childItems: PropTypes.arrayOf(
        PropTypes.shape({ url: PropTypes.string, text: PropTypes.string })
      ),
    })
  ),
  headerButton: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
  }),
};

MobileNav.defaultProps = {
  links: [],
  headerButton: null,
};

export default MobileNav;
